function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11335_138232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.24687 3.44562V7.09062L9.67687 8.30562M13.3219 7.09062C13.3219 10.4458 10.602 13.1656 7.24687 13.1656C3.89174 13.1656 1.17188 10.4458 1.17188 7.09062C1.17188 3.73549 3.89174 1.01562 7.24687 1.01562C10.602 1.01562 13.3219 3.73549 13.3219 7.09062Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11335_138232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 13.5,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.5 0.34375)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpClock);
export default __webpack_public_path__ + "static/media/erpClock.b961669ab9f2c69dbb5372214aff3f33.svg";
export { ForwardRef as ReactComponent };